import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = ({ theme, toggleTheme }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    // Close menu when route changes
    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    // Prevent scrolling when menu is open
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isMenuOpen]);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    const navLinks = [
        { path: '/', label: 'Home' },
        { path: '/about', label: 'About' },
        { path: '/experience', label: 'Experience' },
        { path: '/certifications', label: 'Certifications' },
        { path: '/projects', label: 'Projects' },
        { path: '/skills', label: 'Skills' },
        { path: '/education', label: 'Education' },
        { path: '/contact', label: 'Contact' }
    ];

    return (
        <header className={isMenuOpen ? 'menu-active' : ''}>
            <Link to="/" className="logo" onClick={closeMenu}>
                <i className="fas fa-chart-line"></i>
                <div className="logo-text-group">
                    <h1>Monil Shah</h1>
                    <span className="logo-role">Data Analyst</span>
                </div>
            </Link>

            <div className="header-controls">
                <button 
                    className="theme-toggle-btn" 
                    onClick={toggleTheme} 
                    aria-label="Toggle Theme"
                >
                    {theme === 'light' ? (
                        <i className="fas fa-moon"></i>
                    ) : (
                        <i className="fas fa-sun"></i>
                    )}
                </button>

                <button 
                    className={`menu-icon ${isMenuOpen ? 'active' : ''}`} 
                    onClick={toggleMenu}
                    aria-label="Toggle navigation"
                >
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </button>
            </div>

            <nav className={`nav-panel ${isMenuOpen ? 'active' : ''}`}>
                <ul className="nav-links">
                    {navLinks.map((link, index) => (
                        <li 
                            key={link.path} 
                            style={{ '--index': index }}
                            className={location.pathname === link.path ? 'active' : ''}
                        >
                            <Link to={link.path} onClick={closeMenu}>
                                <span className="link-num">0{index + 1}</span>
                                <span className="link-text">{link.label}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>

            <div 
                className={`menu-overlay ${isMenuOpen ? 'active' : ''}`} 
                onClick={closeMenu}
            ></div>
        </header>
    );
};

export default Header; 